import Axios from "axios";
const request2 = Axios.create({
  // baseURL: "/api",
  baseURL: "https://zbt.haopan.net/ztbmanage/",
  timeout: 5000,
});

request2.interceptors.response.use((response) => {
  return response.data;
});
export default request2;
